/**
 * Logout Controller
 */
(function () {

    angular.module('app.mfaredirect')
        .controller('MfaredirectController', MfaredirectController);

    MfaredirectController.$inject = ['authentication', 'authenticationSettings', '$location', '$rootScope', '$window'];
    function MfaredirectController(authentication, authenticationSettings, $location, $rootScope,$window) {

        var vm = this; 
        vm.errorMessage = '';        
        redirect(); 
       
        function redirect() {            
            var clientId = $location.search().clientId.toUpperCase(); 
            var nonce = $location.search().nonce.toUpperCase();
            vm.mfaredirect = true;
            if (notNullOrUndefined($location.search().error)) {
                vm.errorMessage = $location.search().error;
            }
            if (clientId == authenticationSettings.welcomePointCacheKey) {
                if (vm.errorMessage == '') {
                    $rootScope.redirectURL =
                        authenticationSettings.welcomePointUrl + '/#/login/mfa/' + nonce+'/' + vm.mfaredirect+ '/';
                }
                else {
                    vm.mfaredirect = false;
                    $rootScope.redirectURL =
                        authenticationSettings.welcomePointUrl + '/#/login/mfa/' + nonce + '/'+ vm.mfaredirect + '/' + vm.errorMessage;
                 
                }
            }
            else {
                if (vm.errorMessage != '') {
                    var url = authenticationSettings.ssoUrl + '/#/logout/?clientId=' + clientId;
                    $rootScope.errorMessage = vm.errorMessage;
                    localStorage.setItem('mfaredirect', 'false');
                    authentication.logout();
                    $window.location.href = url;
                    return;
                }                     
                var authData = JSON.parse(localStorage.getItem('cookiedata'));
                authentication.setAuthDataCookie(authData);
                localStorage.setItem('mfaredirect', 'true');
                switch (clientId) {                    
                    case authenticationSettings.cpoCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.cpoUrl;
                        break;
                    case authenticationSettings.dealerSettingsCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.dealerSettingsUrl;
                        break;
                    case authenticationSettings.multiPointCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.multiPointUrl;
                        break;
                    case authenticationSettings.packageEditorCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.packageEditorUrl;
                        break;
                    case authenticationSettings.reportingCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.reportingUrl;
                        break;  
                    
                    case authenticationSettings.shopProvisioningCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.shopProvisioningUrl + '/#/organization';
                        break;
                    case authenticationSettings.avenueCacheKey:
                        $rootScope.redirectURL =
                            authenticationSettings.avenueUrl;
                        break;
                }               
            }
            $window.location.href = $rootScope.redirectURL;
        }       

        function notNullOrUndefined(value) {
            return value !== undefined && value !== 'undefined' && value !== null;
        }
	}
})();